import { Link } from 'react-router-dom'
import { User } from '../../utils/interfaces'
import { Avatar, Logo } from '../../utils/svgs'
import { useState } from 'react';
import { useEventListener } from '@iwbam/react-ez';
import { Auth } from 'aws-amplify';

const Navbar = ({ user, setUser }: { user: undefined | null | User, setUser: React.Dispatch<React.SetStateAction<undefined | null | User>> }) => {

  const [showMenu, setShowMenu] = useState(false);

  useEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest('.menu')) setShowMenu(false);
  })

  // logout
  const logout = async () => {
    await Auth.signOut();
    setUser(null);
    setShowMenu(false);
  }

  return (
    <header className='h-12 border-b bg-neutral-950 border-b-gray-800 flex items-center justify-between px-8'>
      <Link className='flex items-center' to={'/'}>
        <div className='w-8'><Logo /></div>
        {/* <div className='ml-2 font-bold'>LootingV</div> */}
      </Link>
      {user === null || user?.username === 'user' ?
        <Link className='font-bold text-gray-400 hover:text-emerald-500' to={'/login'}>Log in</Link>
      : user ?
        <div className='relative menu'>
          <div className='avatar w-7 cursor-pointer p-1' onClick={() => setShowMenu(true)}><Avatar /></div>
          {showMenu && <menu className='absolute right-0 w-48 py-1 bg-gray-700 border rounded z-40' style={{ top: '120%' }}>
            <div className='p-1 px-2'>
              <div className='font-bold'>{user.username}</div>
            </div>
            <button onClick={logout} className='text-left block w-full p-1 px-2 text-sm hover:bg-gray-600 shadow-xl'>Log out</button>
          </menu>}
        </div>
      : <></>}
    </header>
  )
}

export default Navbar